export default "Overview of today's workshop sections.\n"